import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Helmet} from "react-helmet";

import {openPopup} from "../../general/Modal/action";
import {MODALS} from '../../general/Modal/constants';
import SecondaryNav from '../../general/SecondaryNav';
import {getCookiePolicyContent} from './actions';
import {getLang} from "../../../../utils/common";
import {getRouting} from '../../../../utils/common';

class CookiePolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      infoNodeId: ''
    }
  }

  componentDidMount = () => {
    this.loadHandler();
  };



  loadHandler = async () => {
    const {getCookiePolicyContent} = this.props;
    getCookiePolicyContent();
  };

  render() {
    const {cookiePolicy} = this.props;
    return (
      <div>
      <SecondaryNav {...this.props}/>
      <div className="scheme-banner">
        <h1 className="container-930">{cookiePolicy.title}</h1>
      </div>
      {
        cookiePolicy.body != null
          ? <div className="product-content container" dangerouslySetInnerHTML={{
                __html: cookiePolicy.body
              }}/>
          : <NoContent/>
      }

      </div>
    )
  }
}
const mapStateToProps = (state) => ({
    cookiePolicy : state.cookiePolicy.list,
});

const mapDispatchToProps = (dispatch) => ({
    getCookiePolicyContent: bindActionCreators(getCookiePolicyContent, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CookiePolicy);
